import React from 'react';
import styles from '../search.module.css';

export default function Suggestions({ suggestions , onSuggestionClick }) {
    if (!suggestions || suggestions.length === 0) {
        return null; // No suggestions to display
      }
  return (
    <div className={styles.suggestionsModal}>
    <div className={styles.suggestionsHeader}>
      <h3 className={styles.suggestionsTitle}>Domain Suggestions</h3>
    </div>
    <div className={styles.suggestionsList}>
    {suggestions.map((suggestion, index) => (
        <div key={index} className={styles.suggestionItem} onClick={() => onSuggestionClick(suggestion)}>{suggestion}</div>
      ))}
    </div>
  </div>
  );
}
